class Info {
  static exps = null;

  static I = (path) => {
    Info.exps = Info.exps || (window.site_config || {}).info || {};

    var value = Info.exps;

    path.split('.').forEach(function (p) { if (value != null) value = value[p]; });

    return value;
  }
}

export { Info };